import React from 'react';
import { Grid } from '@material-ui/core';
import dayjs from 'dayjs';
import { useLocale } from 'hooks';

import { InfoBlock } from 'ui';
import {
  AssetActiveIcon,
  CalendarIcon,
  ChemicalTypeIcon,
  FactoryIcon,
  GlobeIcon,
  SuccessIcon,
  WeightIcon,
} from 'ui/icons';
import { useStyles } from '../DesktopAssetsDetails.styles';
import { Asset } from 'hooks/useAssets/useAssets.types';

export const ManufacturerDetails = ({ dateOfIssue, capacity, weight, manufacturer, origin, chemicalType }: Asset) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <InfoBlock
          className={classes.box}
          items={[
            {
              text: manufacturer?.name ?? '',
              label: formatMessage({ id: 'asset_details.manufacturer' }),
              textIcon: FactoryIcon,
              labelIcon: SuccessIcon,
            },
            {
              text: origin,
              label: formatMessage({ id: 'asset_details.origin' }),
              textIcon: GlobeIcon,
              labelIcon: SuccessIcon,
            },
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <InfoBlock
          className={classes.box}
          items={[
            {
              text: chemicalType ?? '',
              label: formatMessage({ id: 'asset_details.chemicalType' }),
              textIcon: ChemicalTypeIcon,
              labelIcon: SuccessIcon,
            },
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <InfoBlock
          className={classes.box}
          items={[
            {
              text: dateOfIssue ? dayjs(dateOfIssue).format('YYYY-MM-DD') : '',
              label: formatMessage({ id: 'asset_details.dateOfIssue' }),
              textIcon: CalendarIcon,
            },
            {
              text: formatMessage({ id: 'asset_details.capacity_value' }, { value: capacity }),
              label: formatMessage({ id: 'asset_details.capacity' }),
              textIcon: AssetActiveIcon,
            },
            {
              text: formatMessage({ id: 'asset_details.weight_value' }, { value: weight }),
              label: formatMessage({ id: 'asset_details.weight' }),
              textIcon: WeightIcon,
            },
          ]}
        />
      </Grid>
    </Grid>
  );
};
